/**
 * Simple utilities for Arabic text display on thermal printers
 */

/**
 * Prepares Arabic text for printing with minimal styling
 * 
 * @param {string} text - The Arabic text to prepare
 * @returns {string} - Print-ready text with minimal styling
 */
export const preparePrinterArabicText = (text) => {
  if (!text) return '';
  
  // More robust approach with better RTL handling
  return `<span style="
    font-family: Tahoma, Arial, 'Simplified Arabic', sans-serif;
    direction: rtl;
    unicode-bidi: bidi-override;
    text-align: right;
    white-space: normal;
    letter-spacing: 0;
    display: inline-block;
  ">${text}</span>`;
};

/**
 * Format numbers for display
 * @param {string|number} num - The number to format
 * @returns {string} - Formatted number
 */
export const formatPrinterNumber = (num) => {
  if (num === undefined || num === null) return '';
  
  // Ensure it's a string
  const numStr = String(num);
  
  // Map of western to eastern Arabic numerals
  const arabicNumerals = {
    '0': '٠', '1': '١', '2': '٢', '3': '٣', '4': '٤',
    '5': '٥', '6': '٦', '7': '٧', '8': '٨', '9': '٩'
  };
  
  // Replace each digit with its Arabic equivalent
  let arabicNum = '';
  for (const digit of numStr) {
    arabicNum += arabicNumerals[digit] || digit;
  }
  
  return arabicNum;
};

/**
 * Simple text presentation for display
 * @param {string} text - The text to format
 * @returns {string} - Text with minimal styling
 */
export const textAsImage = (text) => {
  if (!text) return '';
  
  // Simplified approach
  return preparePrinterArabicText(text);
};
